import React, {useEffect, useMemo, useState} from "react";
import DayJS from "dayjs";
import {useNavigate} from "react-router-dom";
import ChainedContext from "../../../contexts/chainedContext";
import MemberReceiver from "../../../contexts/member_context/Member_Receiver";
import {Skeleton} from "../../../components/ui/skeleton";
import Box from "../../../components/common/Box";
import Stat from "../../../components/common/Stat";
import API from "../../../api";
import {toast} from "react-hot-toast";

const Events = ({member}) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [attendance, setAttendance] = useState([]);
  const [filterByType, setFilterByType] = useState(null);

  useEffect(() => {
    API.member.event.attendance(member._id).then(res => {
      setAttendance(res);
      setLoading(false);
    }).catch(err => {
      toast.error("Unable to retrieve deployment data from server at this time. ERROR: " + err.message)
    });
  }, [member]);

  const fixedAttendance = useMemo(() => {
    return attendance.map(a => {
      return {
        ...a,
        event: {
          ...a.event,
          eventType: a.event.isCpdEvent ? "[CPD]" : a.event.eventType
        }
      }
    }).sort((a, b) => {
      if(a.event.start > b.event.start) return -1;
      if(a.event.start < b.event.start) return 1;
      return 0;
    })
  }, [attendance]);
  const eventTypes = useMemo(() => {
    return fixedAttendance.reduce((acc, item) => {
      if(acc.indexOf(item.event.eventType) === -1) acc.push(item.event.eventType);

      return acc;
    }, []).sort((a, b) => {
      if(a > b) return 1;
      if(a < b) return -1;
      return 0;
    })
  }, [fixedAttendance])
  const filteredList = useMemo(() => {
    return fixedAttendance.filter(item => {
      if(filterByType === null) return true;

      return item.event.eventType === filterByType
    })
  }, [fixedAttendance, filterByType]);

  const handleEventClick = (ev) => {
    if (ev.isRecruitEvent !== undefined && ev.isRecruitEvent) {
      navigate(`/recruitment/events/event/${ev._id}`);
    } else {
      navigate(`/events/event/${ev._id}`);
    }
  };

  return (
    <div className="w-full p-2">
      {loading && (
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-8">
            <Skeleton className="h-80 w-full bg-zinc-200 p-4 dark:bg-zinc-700"></Skeleton>
            <Skeleton className="h-80 w-full bg-zinc-200 p-4 dark:bg-zinc-700"></Skeleton>
          </div>
          <div className=" space-y-8">
            <Skeleton className="h-52 w-full bg-zinc-200 p-4 dark:bg-zinc-700"></Skeleton>
            <Skeleton className="h-20 w-full bg-zinc-200 p-4 dark:bg-zinc-700"></Skeleton>
            <Skeleton className="h-20 w-full bg-zinc-200 p-4 dark:bg-zinc-700"></Skeleton>
          </div>
        </div>
      )}
      {!loading && <>
        <Box title={"Event Attendance"}>
          <div className="flex flex-wrap gap-2 p-2">
            {eventTypes.map((item, i) => {
              return (
                <Stat
                  key={i}
                  label={item}
                  action={() => setFilterByType(item)}
                  colour={filterByType === item ? "bg-blue-300 bg-opacity-40" : undefined}
                />
              );
            })}
          </div>
          {filterByType !== null && <button onClick={() => setFilterByType(null)} className={"ml-2 rounded-md border border-transparent bg-red-100 text-red-900 px-4 py-2 text-sm font-medium hover:bg-red-200"}>Clear Filter</button>}

          <table className="tableClass">
            <thead>
              <tr className="tableHeadRowClass">
                <th className="tableHeadCellClass">Title</th>
                <th className="tableHeadCellClass">Type</th>
                <th className="tableHeadCellClass">Start At</th>
                <th className="tableHeadCellClass">End At</th>
                <th className="tableHeadCellClass">Response</th>
              </tr>
            </thead>
            <tbody className="tableBodyClass">{filteredList.map(eventResponse => {
              return (
                <tr key={eventResponse._id} onClick={() => handleEventClick(eventResponse.event)} className="tableBodyRowClass cursor-pointer">
                  <td className="tableBodyCellClass">{eventResponse.event.title}</td>
                  <td className="tableBodyCellClass">{eventResponse.event.eventType}</td>
                  <td className="tableBodyCellClass">{DayJS(eventResponse.event.start).format("DD-MM-YYYY HH:mm")}</td>
                  <td className="tableBodyCellClass">{eventResponse.event.allDay ? "[All Day]" : DayJS(eventResponse.event.end).format("DD-MM-YYYY HH:mm")}</td>
                  <td className="tableBodyCellClass">{eventResponse.response ? "Yes" :  "No"}</td>
                </tr>
              );
            })}</tbody>
          </table>
        </Box>
      </>}
    </div>
  );
}
export default ChainedContext(Events, [
  [MemberReceiver, "member"],
]);